var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** Backend error type returned when a deleted person is still held by a title. */
export var PERSON_HAS_CHILDREN = "-13";
/** Error parameter carrying one name of a title holding the person (repeated per title). */
var PARAM_TITLE = "title";
/** Error parameter carrying the total number of titles holding the person. */
var PARAM_TITLE_COUNT = "titleCount";
var isErrorWithJsonResponse = function (error) {
    var _a;
    return typeof error === "object" &&
        error !== null &&
        "response" in error &&
        typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.json) === "function";
};
/**
 * Reads the error type and the titles holding the person from a failed delete request.
 * The response body is read only once.
 *
 * @param error the value thrown by the delete request
 * @returns the error type (if any) with the holding titles and their total count
 */
export var parsePersonDeleteError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var empty, firstError, parameters, titles, countValue, parsedCount, _a;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                empty = {
                    code: undefined,
                    titles: [],
                    titleCount: 0,
                };
                if (!isErrorWithJsonResponse(error)) {
                    return [2 /*return*/, empty];
                }
                _f.label = 1;
            case 1:
                _f.trys.push([1, 3, , 4]);
                return [4 /*yield*/, error.response.json()];
            case 2:
                firstError = (_c = (_b = (_f.sent())) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0];
                parameters = (_d = firstError === null || firstError === void 0 ? void 0 : firstError.parameters) !== null && _d !== void 0 ? _d : [];
                titles = parameters
                    .filter(function (p) { return p.key === PARAM_TITLE && p.value; })
                    .map(function (p) { return p.value; });
                countValue = (_e = parameters.find(function (p) { return p.key === PARAM_TITLE_COUNT; })) === null || _e === void 0 ? void 0 : _e.value;
                parsedCount = Number(countValue);
                return [2 /*return*/, {
                        code: firstError === null || firstError === void 0 ? void 0 : firstError.type,
                        titles: titles,
                        titleCount: Number.isFinite(parsedCount)
                            ? Math.max(parsedCount, titles.length)
                            : titles.length,
                    }];
            case 3:
                _a = _f.sent();
                return [2 /*return*/, empty];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Builds the user message for a failed person delete. When the person is held by titles,
 * the message names them (and how many more there are).
 *
 * @param formatMessage react-intl formatMessage
 * @param entity translation namespace of the person kind
 * @param error the parsed delete error
 * @returns the localized message
 */
export var buildPersonDeleteErrorMessage = function (formatMessage, entity, error) {
    if (error.code !== PERSON_HAS_CHILDREN) {
        return formatMessage({ id: "ui-br-agency.".concat(entity, ".error.delete") });
    }
    if (error.titles.length === 0) {
        return formatMessage({ id: "ui-br-agency.".concat(entity, ".delete.children") });
    }
    return formatMessage({ id: "ui-br-agency.".concat(entity, ".delete.childrenWithTitles") }, {
        titles: error.titles.join(", "),
        more: error.titleCount - error.titles.length,
    });
};
